<template>

  <section id="tour_details_main" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="terms_service_content">
            <div class="terms_item">
              <h4></h4>
              <section class="terms_item">
  <h4>Terms &amp; Conditions – SayarahGo</h4>

  <h4>What’s in These Terms?</h4>
  <p>
    These Terms &amp; Conditions (“Terms”) explain the rules for using the SayarahGo
    mobile application, website, and related services (collectively referred to as the “Platform”).
  </p>
  <p>
    They govern how you access, use, and interact with SayarahGo, including booking rides,
    communicating with drivers, making payments, and using any related features.
  </p>
  <p>
    References to the Platform include all versions of the SayarahGo app, website,
    and any updates, derivatives, or services accessed via mobile phone, tablet,
    or other devices.
  </p>

  <h4>Who We Are and How to Contact Us</h4>
  <p>
    SayarahGo is a ride-hailing and transportation platform operating in Dubai,
    United Arab Emirates (“we”, “our”, or “us”).
  </p>
  <p>
    SayarahGo connects passengers with independent third-party drivers for transportation services.
    SayarahGo does not itself provide transportation services unless explicitly stated.
  </p>
  <p>
    To contact us, please use the in-app support feature or official customer service channels.
  </p>

  <h4>Services We Provide</h4>
  <p>SayarahGo provides a technology platform that enables users to:</p>
  <ul>
    <li>Request and book transportation services</li>
    <li>Be matched with nearby drivers</li>
    <li>View estimated fares and trip details</li>
    <li>Make cashless or cash payments (where available)</li>
    <li>Access trip history and receipts</li>
    <li>Contact customer support</li>
  </ul>
  <p>
    SayarahGo does not guarantee availability of drivers at all times and does not
    operate as a transportation carrier.
  </p>

  <h4>Acceptance of These Terms</h4>
  <p>By accessing or using SayarahGo, you confirm that:</p>
  <ul>
    <li>You have read and understood these Terms</li>
    <li>You agree to be legally bound by them</li>
    <li>You are at least 18 years old or the legal age to enter into a binding contract in the UAE</li>
  </ul>
  <p>
    If you do not agree with these Terms, you must not use the Platform.
  </p>

  <h4>Other Terms That Apply</h4>
  <p>These Terms incorporate and should be read together with:</p>
  <ul>
    <li>Privacy Policy, which explains how we collect and use personal data</li>
    <li>Fare, Payment, and Cancellation Policies, displayed within the app during booking</li>
  </ul>
  <p>
    In the event of a conflict, these Terms will prevail unless otherwise stated.
  </p>

  <h4>Changes to These Terms</h4>
  <p>
    We may update these Terms from time to time. The “Last Updated” date will reflect
    the most recent changes.
  </p>
  <p>
    Material changes will be communicated through the app or other reasonable means.
    Continued use of SayarahGo after changes are posted constitutes acceptance of the updated Terms.
  </p>

  <h4>User Responsibilities</h4>
  <p>You agree to:</p>
  <ul>
    <li>Provide accurate and complete information</li>
    <li>Use the Platform only for lawful purposes</li>
    <li>Not misuse the Platform, drivers, or services</li>
    <li>Treat drivers and support staff respectfully</li>
    <li>Not attempt to damage, interfere with, or access systems unlawfully</li>
  </ul>
  <p>
    You are responsible for all activity conducted through your account.
  </p>

  <h4>Pricing, Payments, and Fees</h4>
  <p>
    Fares are calculated based on distance, time, and applicable pricing rules displayed in the app.
  </p>
  <p>
    Payment methods may include cards, digital wallets, or cash where permitted.
    By using the Platform, you authorize SayarahGo and its payment partners to process
    payments on your behalf.
  </p>
  <p>
    Additional charges such as tolls, waiting time, or cancellation fees may apply
    and will be disclosed where applicable.
  </p>

  <h4>Cancellations and No-Shows</h4>
  <p>
    Cancellation fees may apply if you cancel a ride after a driver has accepted the request
    or if you fail to appear at the pickup location within a reasonable time.
  </p>
  <p>
    Specific cancellation rules are shown in the app at the time of booking.
  </p>

  <h4>Driver Relationship</h4>
  <p>
    Drivers using SayarahGo are independent third-party service providers,
    not employees or agents of SayarahGo.
  </p>
  <p>
    SayarahGo is not responsible for the acts, omissions, or conduct of drivers,
    except as required by applicable law.
  </p>

  <h4>Safety and Conduct</h4>
  <p>
    Users must comply with all applicable laws and regulations while using SayarahGo.
    SayarahGo reserves the right to suspend or terminate accounts for unsafe behavior,
    fraud, abuse, or violations of these Terms.
  </p>

  <h4>Intellectual Property</h4>
  <p>
    All content, trademarks, logos, and software related to SayarahGo are owned by or
    licensed to SayarahGo. You may not copy, modify, distribute, or use any content
    without prior written permission.
  </p>

  <h4>Limitation of Liability</h4>
  <p>
    To the maximum extent permitted by UAE law, SayarahGo shall not be liable for indirect,
    incidental, or consequential damages arising from your use of the Platform or services.
  </p>
  <p>
    SayarahGo’s total liability, where applicable, shall be limited to the amount paid by you
    for the relevant trip.
  </p>

  <h4>Governing Law and Jurisdiction</h4>
  <p>
    These Terms are governed by the laws of the United Arab Emirates.
    Any disputes shall be subject to the exclusive jurisdiction of the competent courts of the UAE.
  </p>

  <h4>Termination</h4>
  <p>
    SayarahGo may suspend or terminate your access to the Platform at any time
    if you violate these Terms or applicable laws.
  </p>
  <p>
    You may stop using the Platform at any time.
  </p>

  <h4>Contact Us</h4>
  <p>
    For questions, complaints, or support regarding these Terms,
    please contact SayarahGo through the in-app support or official communication channels.
  </p>
</section>

            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
   <!-- <Header/>
   <Banner/> -->
   <!-- <PrivacyPolicyBanner /> -->
     

</template>
<script>
// import Banner from '@/components/hometwo/Banner.vue'
// import Header from '@/components/Header.vue'
// import PrivacyPolicyBanner from '@/components/pages/PrivacyPolicyBanner.vue'
    
export default {
  name: "TermsView",
//   comments: {
//     Header, Banner
//   }
};
</script>
<style>
    
</style>
